import axios from "@/api/axios"
import {apiUrlWithLang} from "@/helpers/persistanceStorage";
const getOrders = credentials => {
    let url = apiUrlWithLang('/dashboard/api/orders')
    return axios.get(url, { params:credentials })
}

const getOrderById = (credentials, orderId) => {
    let url = apiUrlWithLang(`/dashboard/api/orders/${orderId}`)
    return axios.get(url, { params:credentials })
}

const cancelOrderById = (credentials, orderId) => {
    let url = apiUrlWithLang(`/dashboard/api/orders/${orderId}/cancel`)
    return axios.post(url, credentials)
}

export default {
    getOrders,
    getOrderById,
    cancelOrderById,
}